import { defineMessages } from "react-intl";

const PREFIX = "UI.Password";
export default defineMessages({
  currentPassword: {
    id: `${PREFIX}.currentPassword`,
    defaultMessage: "Current Password",
  },
  newPassword: {
    id: `${PREFIX}.newPassword`,
    defaultMessage: "New Password",
  },
  confirmPassword: {
    id: `${PREFIX}.confirmPassword`,
    defaultMessage: "Confirm Password",
  },

  isRequired: {
    id: `${PREFIX}.isRequired`,
    defaultMessage: "The field is required",
  },
  mustMatch: {
    id: `${PREFIX}.mustMatch`,
    defaultMessage: "The password must contain lowercase and uppercase letters, numbers, and special characters",
  },
  maxLengthError: {
    id: `${PREFIX}.checkCorrectness`,
    defaultMessage: "The password must contain at least eight characters",
  },
  confirmPasswordNoEqualError: {
    id: `${PREFIX}.confirmPasswordNoEqualError`,
    defaultMessage: "New password and its confirmation must match",
  },
  passwordsIdentityError: {
    id: `${PREFIX}.passwordsIdentityError`,
    defaultMessage: "New password must be different from the current password",
  }
});
